import { db } from '../db';
import { getSettings } from './settingsService';

/**
 * Runs the background cleanup process to remove old synced scouting sessions and media.
 */
export const runCleanup = async (): Promise<void> => {
  try {
    const settings = await getSettings();
    const { retentionDays } = settings;

    if (retentionDays === undefined) return;

    const cutoffDate = new Date();
    cutoffDate.setDate(cutoffDate.getDate() - retentionDays);
    const cutoffString = cutoffDate.toISOString();

    console.log(`[CleanupEngine] Starting cleanup. Retention: ${retentionDays} days. Cutoff: ${cutoffString}`);

    // Identify sessions to delete: synced and older than cutoff
    const sessionsToDelete = await db.scoutingSessions
      .where('syncStatus')
      .equals('synced')
      .and(session => session.date < cutoffString)
      .toArray();

    if (sessionsToDelete.length === 0) {
      console.log('[CleanupEngine] No expired synced records found.');
      return;
    }

    console.log(`[CleanupEngine] Found ${sessionsToDelete.length} sessions for deletion.`);

    for (const session of sessionsToDelete) {
      if (session.id === undefined) continue;

      // A field-scout round re-links its photos to its queue row id, which
      // shares a number space with session ids. Never delete an unsent
      // round's photos.
      const queueRow = await db.fieldScoutQueue.get(session.id);
      const unsentRound = !!queueRow && queueRow.syncStatus !== 'synced';

      // Delete associated media
      const mediaCount = unsentRound
        ? 0
        : await db.media.where('sessionId').equals(session.id).delete();
      
      // Delete session
      await db.scoutingSessions.delete(session.id);
      
      console.log(`[CleanupEngine] Deleted session ${session.uuid} and ${mediaCount} associated media items.`);
    }

    console.log('[CleanupEngine] Cleanup completed successfully.');
  } catch (error) {
    console.error('[CleanupEngine] Cleanup failed:', error);
  }
};
